// API Configuration
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://imo-sprint-api-central-1089729063773.us-central1.run.app'
  : 'http://localhost:5001';

export default API_BASE_URL;
